import { yup } from '@guiker/yup-util'

export const externalIdSchema = yup.object({
  externalId: yup.string().required(),
})
